var _g, _path, _path2, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMedal = function SvgMedal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 144,
    fill: "none",
    viewBox: "0 0 126 144",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#medal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D6",
    fillRule: "evenodd",
    d: "M14.403 111.98c-2.427.447-4.23-2.199-2.928-4.294l42.12-67.754H72.527l42.12 67.754c1.303 2.095-.501 4.741-2.927 4.294l-16.748-3.083a2.842 2.842 0 0 0-3.195 1.851l-6.34 18.018c-.791 2.249-3.819 2.588-5.061.553-4.828-7.909-13.947-23.092-17.315-30.362-3.367 7.27-12.486 22.453-17.315 30.362-1.242 2.035-4.27 1.696-5.06-.553l-6.34-18.018a2.842 2.842 0 0 0-3.195-1.851l-16.748 3.083Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E8FFF",
    fillRule: "evenodd",
    d: "M14.403 111.98c-2.427.447-4.23-2.199-2.928-4.294l42.12-67.754H72.527l42.12 67.754c1.303 2.095-.501 4.741-2.927 4.294l-16.748-3.083a2.842 2.842 0 0 0-3.195 1.851l-6.34 18.018c-.791 2.249-3.819 2.588-5.061.553-4.828-7.909-13.947-23.092-17.315-30.362-3.367 7.27-12.486 22.453-17.315 30.362-1.242 2.035-4.27 1.696-5.06-.553l-6.34-18.018a2.842 2.842 0 0 0-3.195-1.851l-16.748 3.083Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "medal_svg__b",
    width: 105,
    height: 92,
    x: 11,
    y: 39,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.403 111.98c-2.427.447-4.23-2.199-2.928-4.294l42.12-67.754H72.527l42.12 67.754c1.303 2.095-.501 4.741-2.927 4.294l-16.748-3.083a2.842 2.842 0 0 0-3.195 1.851l-6.34 18.018c-.791 2.249-3.819 2.588-5.061.553-4.828-7.909-13.947-23.092-17.315-30.362-3.367 7.27-12.486 22.453-17.315 30.362-1.242 2.035-4.27 1.696-5.06-.553l-6.34-18.018a2.842 2.842 0 0 0-3.195-1.851l-16.748 3.083Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#medal_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.059,
    fillRule: "evenodd",
    d: "M62.571 96.982c23.538 0 42.62-19.081 42.62-42.62 0-23.538-19.082-42.619-42.62-42.619-23.538 0-42.62 19.081-42.62 42.62 0 23.538 19.082 42.619 42.62 42.619Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#medal_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAE24C",
    fillRule: "evenodd",
    d: "M62.572 92.72c23.538 0 42.619-19.081 42.619-42.62 0-23.537-19.081-42.619-42.62-42.619-23.538 0-42.619 19.082-42.619 42.62 0 23.538 19.081 42.62 42.62 42.62Z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#medal_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    fillRule: "evenodd",
    d: "M62.572 84.196c18.83 0 34.095-15.265 34.095-34.096 0-18.83-15.265-34.095-34.095-34.095S28.476 31.27 28.476 50.1s15.265 34.096 34.096 34.096Z",
    clipRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#medal_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4C7",
    fillRule: "evenodd",
    d: "m62.57 62.26-8.133 4.175c-1.708.877-3.682-.578-3.35-2.47l1.539-8.76-6.468-6.154c-1.407-1.34-.647-3.711 1.276-3.984l8.99-1.275 4.072-8.057c.86-1.7 3.288-1.7 4.148 0l4.072 8.057 8.99 1.275c1.923.273 2.683 2.645 1.276 3.984l-6.467 6.155 1.539 8.76c.332 1.89-1.642 3.346-3.35 2.47L62.57 62.26Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "medal_svg__a",
    width: 124.203,
    height: 110.893,
    x: 0.96,
    y: 32.601,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.04
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0942029 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22071_63538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_22071_63538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "medal_svg__c",
    width: 105.398,
    height: 105.398,
    x: 9.873,
    y: 0.151,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.04
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.137681 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22071_63538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_22071_63538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "medal_svg__d",
    width: 68.191,
    height: 72.773,
    x: 28.476,
    y: 16.005,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.749
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.0942029 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22071_63538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_22071_63538",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.582
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0724638 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_22071_63538"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "medal_svg__e",
    width: 45.268,
    height: 43.232,
    x: 39.936,
    y: 31.711,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.749
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0869565 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22071_63538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_22071_63538",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMedal);
export default ForwardRef;